import { paths } from '@/types/api';
import { segmentClient } from '@/util/analytics';
import { fetchClient } from '@/util/fetchClient';
import { Sentry } from '@/util/sentry';

type SupportPath = paths['/v2/contact-support']['post'];

type SupportRequest = SupportPath['requestBody']['content']['application/json'];

type SupportResponse = SupportPath['responses']['200']['content']['application/json'];

export type UserData = NonNullable<SupportRequest['user']>;

export type SupportRequestData = SupportRequest;

export async function sendSupportRequest(data: SupportRequestData): Promise<SupportResponse> {
  try {
    const response = await fetchClient.POST('/v2/contact-support', { body: data });

    if (!response.data) {
      throw new Error('No data received from server');
    }

    segmentClient.track('Support Request Sent', {
      ...data,
    });

    return response.data;
  } catch (error) {
    segmentClient.track('Support Request Failed', {
      error: error instanceof Error ? error.message : 'Unknown error',
      ...data,
    });

    Sentry.captureException(error, {
      tags: {
        feature: 'support-request',
      },
      extra: {
        requestData: data,
      },
    });

    throw error;
  }
}
